import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewFieldSectionsHeaders } = formModuleLenses

export default (state, { moduleId }) => viewFieldSectionsHeaders(
	moduleId, moduleDescriptions,
)
